import $ from 'jquery';
import axios from 'axios';
import { getState, modifyState } from '~src/state';
import Swal from 'sweetalert2';
import { trackEvent } from '~src/tracking';
import {
  showSidebarTab,
  hideSidebarTab,
  handleTabAttachments,
} from '~src/sidebarLegacy';
import { onErrorShowMessage } from '~src/errors';
import { isLoggedUserGlobalEditor, getUser } from '~src/user';
import { requestNewInfoAf, requestInfoEterno } from '~src/userRequest';
import formatDistance from 'date-fns/formatDistance';
import it from 'date-fns/locale/it';
import { mapGiottoProjectEventToAFType } from '~src/sidebar/annunciFunebri/mapGiottoProjectEventToAFType';
import { fetchAnnuncioFunebre } from '~src/sidebar/annunciFunebri/fetchAnnuncioFunebre';
import { fetchRoomReservationsByFuneralService } from '~graphql/controllers';
import {
  fetchClientiByDefuntoJoin,
  fetchDeleganti,
  fetchDelegantiByDefuntoJoin,
} from '../~graphql/controllers/fetchDeleganti';
import { deleteNecrologio } from '../~graphql/controllers/necrologi';
import createAnnuncioFunebre from '../~graphql/controllers/necrologi/createAnnuncioFunebre';
import updateAnnuncioFunebre from '../~graphql/controllers/necrologi/updateAnnuncioFunebre';
import calculateAge from '~src/utils/calculateAge';
import exportProjectToURL from '~core/exportProjectToURL';
import { b64toBlob, saveEditorState } from '~core';
import { cleanBase64 } from '~src/utils';
import { buildAfContactDefaults } from '~src/sidebar/annunciFunebri/contactDefaults';

let isInitAnnunciFunebri = false;

function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const splitted = email.split(',');
  if (splitted.length === 1) {
    return re.test(String(email).toLowerCase());
  } else {
    for (const singleEmail of splitted) {
      if (!re.test(String(singleEmail).toLowerCase().trim())) {
        return false;
      }
    }
    return true;
  }
}

async function getBase64(url) {
  return axios
    .get(url, { responseType: 'arraybuffer' })
    .then((response) => {
      const base64 = btoa(
        new Uint8Array(response.data).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ''
        )
      );

      return `data:${response.headers['content-type']};base64,${base64}`;
    })
    .catch((err) => {
      console.error(err);
    });
}

const initSelect2Comuni = () => {
  $('#editor-sidebar-af-select-ricerca-comuni').select2({
    width: '100%',
    theme: 'bootstrap4',
    placeholder: 'Inserisci 2 caratteri per cercare il Comune',
    language: {
      inputTooShort: function (e) {
        const s = `Inserisci ${e.minimum} caratteri per cercare il Comune`;
        return s;
      },
      searching: function () {
        return 'Sto cercando...';
      },
    },
    ajax: {
      url: `${process.env.SELECT2_API_URL}/comuni`,
      data: function (params) {
        const query = {
          search: params.term,
        };
        return query;
      },
      cache: true,
      placeholder: 'Inserisci 2 letter per cercare',
      allowClear: true,
    },
    minimumInputLength: 2,
  });
};

const showLoaderAf = (text) => {
  Swal.fire({
    text,
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    confirmButtonColor: '#278e8e',
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

const showSuccessAf = (msg) => {
  Swal.hideLoading();
  Swal.fire({
    title: 'Fatto!',
    html: msg,
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });
};

const createOrUpdateInternalAnnuncioFunebre = async (attributes) => {
  const servizio = getState('selected.servizio', {});
  const templatesCategory = getState('selected.templatesCategory');
  const chiesa = getState('selected.servizio.chiese_pointer');

  const fields = {
    defunto_pointer: { link: servizio.objectId },
    tipo: mapGiottoProjectEventToAFType(templatesCategory.name.toLowerCase()),
    pubblicato: true,
  };

  if (attributes.comune) {
    fields.comune = attributes.comune;
  }

  if (attributes.link_annuncifunebri) {
    fields.link_annuncifunebri = attributes.link_annuncifunebri;
  }

  if (attributes.link_cliente) {
    fields.link_cliente = attributes.link_cliente;
  }

  if (attributes.visibile !== undefined) {
    fields.visibile = attributes.visibile;
  }

  if (attributes.sms_famiglia) {
    fields.sms_famiglia = attributes.sms_famiglia;
  }

  if (attributes.mail_famiglia) {
    fields.mail_famiglia = attributes.mail_famiglia;
  }

  if (attributes.fotoUrl) {
    fields.foto = {
      file: {
        __type: 'File',
        name: attributes.fotoFilename,
        url: attributes.fotoUrl,
      },
    };
  }

  if (attributes.manifestoUrl) {
    fields.manifesto = {
      file: {
        __type: 'File',
        name: attributes.manifestoFilename,
        url: attributes.manifestoUrl,
      },
    };
  }

  if (servizio.data_morte) {
    fields.data_morte = servizio.data_morte.substr(0, 10);
  }

  if (chiesa && chiesa.nome) {
    fields.nome_chiesa = chiesa.nome;
  }
  if (chiesa && chiesa.indirizzo) {
    fields.indirizzo_chiesa = chiesa.indirizzo;
  }
  if (chiesa && chiesa.citta) {
    fields.citta_chiesa = chiesa.citta;
  }

  if (servizio.cimitero) {
    fields.nome_cimitero = servizio.cimitero;
  }

  if (servizio.data_funerale) {
    fields.data_funerale = servizio.data_funerale.substr(0, 10);
  }

  if (servizio.nome) {
    fields.nome = servizio.nome;
  }

  if (servizio.cognome) {
    fields.cognome = servizio.cognome;
  }

  let objectId;
  if (window.editorConfig.annunciFunebri?.objectId) {
    objectId = await updateAnnuncioFunebre(
      window.editorConfig.annunciFunebri.objectId,
      fields
    );
  } else {
    objectId = await createAnnuncioFunebre(fields);
  }

  // Fetch the complete data after create/update
  const response = await fetchAnnuncioFunebre();

  // If fetch returns null, return at least the objectId so we can use it
  if (!response && objectId) {
    const minimalResponse = { objectId };
    window.editorConfig.annunciFunebri = minimalResponse;
    return minimalResponse;
  }

  window.editorConfig.annunciFunebri = response;
  return response;
};

const getAfFormData = () => {
  let comune;
  try {
    comune = $('#editor-sidebar-af-select-ricerca-comuni').select2('data')[0]
      .element;
    // eslint-disable-next-line no-empty
  } catch (err) {}

  const mail_famiglia = $('#editor-sidebar-af-family-email').val();
  const sms_famiglia = $('#editor-sidebar-af-family-whatsapp').val();
  const annuncioVisible = document.getElementById(
    'editor-sidebar-af-checkbox-annuncio-visible'
  ).checked;

  return {
    comune,
    annuncioVisible,
    mail_famiglia,
    sms_famiglia,
  };
};

const validateAf = () => {
  const { comune, mail_famiglia } = getAfFormData();

  if (!comune || !comune.value) {
    onErrorShowMessage(false, {
      icon: 'warning',
      title: 'Attenzione',
      text: 'Inserisci il comune di affissione',
    });

    $('#editor-sidebar-af-select-ricerca-comuni')
      .parent()
      .addClass('has-error');

    return false;
  } else {
    $('#editor-sidebar-af-select-ricerca-comuni')
      .parent()
      .removeClass('has-error');
  }

  if (mail_famiglia && !validateEmail(mail_famiglia)) {
    onErrorShowMessage(false, {
      title: 'Oops',
      text: 'Indirizzo email non valido',
    });
    $('#editor-sidebar-af-family-email').parent().addClass('has-error');

    return false;
  } else {
    $('#editor-sidebar-af-family-email').parent().removeClass('has-error');
  }

  return true;
};

const fetchAfDefaultContacts = async () => {
  const servizio = getState('selected.servizio', {});

  if (!servizio.objectId) {
    return {
      email: '',
      whatsapp: '',
    };
  }

  const defuntoWhere = {
    defunto_pointer: {
      have: { objectId: { equalTo: servizio.objectId } },
    },
  };
  const enabledDefuntoWhere = {
    ...defuntoWhere,
    stato: { notEqualTo: 'Disabilitato' },
  };

  const [legacyDeleganti, joinedDeleganti, clienti] = await Promise.all([
    fetchDeleganti(enabledDefuntoWhere, false),
    fetchDelegantiByDefuntoJoin(enabledDefuntoWhere),
    fetchClientiByDefuntoJoin(defuntoWhere),
  ]);

  return buildAfContactDefaults({
    deleganti: [...(joinedDeleganti || []), ...(legacyDeleganti || [])],
    clienti: clienti || [],
  });
};

const checkAndEnableAfButton = async () => {
  if (
    window.editorConfig.annunciFunebri?.link_annuncifunebri ||
    window.editorConfig.annunciFunebri?.link_cliente
  ) {
    $('#editor-sidebar-af-show-annuncio').show();
    $('#editor-sidebar-af-updatedAt').show();
  } else {
    $('#editor-sidebar-af-show-annuncio').hide();
    $('#editor-sidebar-af-updatedAt').hide();
  }

  // Show/hide and configure Eterno promo box
  if (window.editorConfig.annunciFunebri?.objectId) {
    const { user } = await getUser();
    const isGiottoOnly = user?.org_pointer?.tipo_licenza === 'giotto';

    if (isGiottoOnly) {
      // User has Giotto-only license: show info request instead of Eterno link
      $('#editor-sidebar-af-eterno-box-title').text(
        "Vuoi arricchire l'annuncio?"
      );
      $('#editor-sidebar-af-eterno-box-text').text(
        'Con Eterno puoi aggiungere testi personalizzati, dettagli del rosario, streaming del funerale e molto altro. Richiedi informazioni per saperne di più.'
      );
      $('#editor-sidebar-af-eterno-btn')
        .text('Richiedi Informazioni')
        .off('click')
        .on('click', () => {
          requestInfoEterno();
        });
      // Hide contact link for Giotto-only users
      $('#editor-sidebar-af-eterno-contact-link').addClass('d-none');
    } else {
      // User has Eterno access: show direct link
      const servizio = getState('selected.servizio', {});
      const defuntoId = servizio.objectId || '';
      const annuncioId = window.editorConfig.annunciFunebri.objectId;
      const eternoUrl = `${process.env.ETERNO_URL}/index.php?page=detaildefunto&objectid=${defuntoId}&annuncioId=${annuncioId}`;

      $('#editor-sidebar-af-eterno-box-title').text(
        "Vuoi arricchire l'annuncio?"
      );
      $('#editor-sidebar-af-eterno-box-text').text(
        'Su Eterno puoi aggiungere testi personalizzati, dettagli del rosario, streaming del funerale e molto altro.'
      );
      $('#editor-sidebar-af-eterno-btn')
        .text('Completa su Eterno')
        .off('click')
        .on('click', () => {
          window.open(eternoUrl, '_blank');
        });

      // Show contact link for Eterno users
      $('#editor-sidebar-af-eterno-contact-link').removeClass('d-none');
      $('#editor-sidebar-af-eterno-contact')
        .off('click')
        .on('click', (e) => {
          e.preventDefault();
          requestInfoEterno();
        });
    }
    $('#editor-sidebar-af-eterno-box').removeClass('d-none');
  } else {
    $('#editor-sidebar-af-eterno-box').addClass('d-none');
  }

  const comuneFromConfig = window.editorConfig.annunciFunebri?.comune;
  if (comuneFromConfig?.nome) {
    const defaultOption = new Option(
      comuneFromConfig.nome,
      comuneFromConfig.codice,
      false,
      false
    );

    defaultOption.setAttribute('data-nome', comuneFromConfig.nome);

    $('#editor-sidebar-af-select-ricerca-comuni')
      .append(defaultOption)
      .trigger('change');
  }

  if (window.editorConfig.annunciFunebri?.updatedAt) {
    $('#editor-sidebar-af-delete-annuncio').show();

    $('#editor-sidebar-af-updatedAt').text(
      `Pubblicato da ${formatDistance(
        new Date(window.editorConfig.annunciFunebri.updatedAt),
        new Date(),
        { addSuffix: false, locale: it }
      )}`
    );
  } else {
    $('#editor-sidebar-af-delete-annuncio').hide();
  }

  let defaultContacts = {
    email: '',
    whatsapp: '',
  };
  if (
    !window.editorConfig.annunciFunebri?.mail_famiglia ||
    !window.editorConfig.annunciFunebri?.sms_famiglia
  ) {
    defaultContacts = await fetchAfDefaultContacts();
  }

  if (window.editorConfig.annunciFunebri?.mail_famiglia) {
    $('#editor-sidebar-af-family-email').val(
      window.editorConfig.annunciFunebri.mail_famiglia
    );
  } else {
    $('#editor-sidebar-af-family-email').val(defaultContacts.email);
  }

  if (window.editorConfig.annunciFunebri?.sms_famiglia) {
    $('#editor-sidebar-af-family-whatsapp').val(
      window.editorConfig.annunciFunebri.sms_famiglia
    );
  } else {
    $('#editor-sidebar-af-family-whatsapp').val(defaultContacts.whatsapp);
  }

  if (window.editorConfig.annunciFunebri?.visibile !== undefined) {
    $('#editor-sidebar-af-checkbox-annuncio-visible').bootstrapToggle(
      window.editorConfig.annunciFunebri.visibile ? 'on' : 'off'
    );
  }

  if (window.editorConfig.annunciFunebri?.foto?.url) {
    modifyState(
      'afSelectPhotoUrl',
      window.editorConfig.annunciFunebri.foto.url
    );
    $('#editor-sidebar-af-select-photo-description').hide();
    $('#editor-sidebar-af-photo')
      .attr('src', window.editorConfig.annunciFunebri.foto.url)
      .show();
  } else {
    // Reset photo display if no photo
    modifyState('afSelectPhotoUrl', null);
    $('#editor-sidebar-af-select-photo-description').show();
    $('#editor-sidebar-af-photo').hide().attr('src', '');
  }

  const linkAnnuncioEsterno =
    window.editorConfig.annunciFunebri?.link_cliente ||
    window.editorConfig.annunciFunebri?.link_annuncifunebri;

  if (linkAnnuncioEsterno) {
    $('#editor-sidebar-af-show-annuncio')
      .parent('a')
      .attr('href', linkAnnuncioEsterno);
  }
};

export const deleteExternalAnnuncioFunebre = async () => {
  const confirmResult = await Swal.fire({
    title: 'Conferma eliminazione',
    text: "Sei sicuro di voler eliminare l'annuncio funebre?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#278e8e',
    confirmButtonText: 'Sì, elimina',
    cancelButtonText: 'Annulla',
  });

  if (!confirmResult.isConfirmed) {
    return;
  }

  showLoaderAf("Sto eliminando l'annuncio funebre...");

  const { user } = await getUser();

  const necrologioId = window.editorConfig.annunciFunebri.objectId;

  const data = {
    codice_impresa: user.org_pointer.objectId,
    codice_annuncio: necrologioId,
  };

  try {
    const response = await axios.post(
      `${process.env.ANNUNCI_FUNEBRI_API_URL}/delete`,
      { data }
    );
    if (response.data.code > 300) {
      throw response.data;
    }
    await deleteNecrologio(necrologioId);
    window.editorConfig.annunciFunebri = null;
  } catch (err) {
    console.error(err);
    onErrorShowMessage(false, {
      icon: 'error',
      title: 'Errore',
      text: "Non è stato possibile eliminare l'annuncio su AnnunciFunebri.it",
      confirmButtonColor: '#278e8e',
    });
    return;
  }

  showSuccessAf("L'annuncio &egrave; stato eliminato con successo.");

  // Reset all form fields
  $('#editor-sidebar-af-select-ricerca-comuni').val(null).trigger('change');
  $('#editor-sidebar-af-family-email').val('');
  $('#editor-sidebar-af-family-whatsapp').val('');
  $('#editor-sidebar-af-checkbox-annuncio-visible').bootstrapToggle('on');
  modifyState('afSelectPhotoUrl', null);
  $('#editor-sidebar-af-select-photo-description').show();
  $('#editor-sidebar-af-photo').hide().attr('src', '');
  $('#editor-sidebar-af-show-annuncio').hide();
  $('#editor-sidebar-af-delete-annuncio').hide();
  $('#editor-sidebar-af-eterno-box').addClass('d-none');
  $('#editor-sidebar-af-updatedAt').hide().text('');

  await checkAndEnableAfButton();
};

export const publishExternalAnnuncioFunebre = async () => {
  const isGlobalEditor = await isLoggedUserGlobalEditor();
  if (isGlobalEditor) {
    onErrorShowMessage(false, {
      icon: 'error',
      title: 'Errore',
      text: 'Impossibile pubblicare annunci con Editor Admin',
      confirmButtonColor: '#278e8e',
    });
  }

  const { user } = await getUser();

  if (!validateAf()) {
    return;
  }

  // Save the project before publishing
  await saveEditorState(true, true);

  const {
    comune,
    annuncioVisible,
    mail_famiglia,
    sms_famiglia,
  } = getAfFormData();

  const servizio = getState('selected.servizio');
  const chiesa = getState('selected.servizio.chiese_pointer');
  const templatesCategory = getState('selected.templatesCategory');

  const foto = getState('afSelectPhotoUrl');

  showLoaderAf("Sto pubblicando l'annuncio funebre...");

  let fotoUrl;
  let fotoFilename;
  if (foto) {
    const fotoBase64 = await getBase64(foto);
    const base64Clean = cleanBase64(fotoBase64);
    const blob = b64toBlob(base64Clean.base64, base64Clean.contentType);

    const ephemeralUploader = getState('uploader.ephemeral');
    ephemeralUploader.addFile({
      type: blob.type,
      data: blob,
    });

    const responseUpload = await ephemeralUploader.upload();
    ephemeralUploader.cancelAll();

    const uploadedPathname = new URL(responseUpload.successful[0].uploadURL)
      .pathname;
    fotoUrl = `${process.env.EDGE_RESIZER}${uploadedPathname}`;
    fotoFilename = uploadedPathname.substring(1); // Remove leading slash to get filename
  }

  const projectExportUrl = await exportProjectToURL({
    quality: 0.85,
    outputDpi: 72,
    format: 'base64',
    imageFormat: 'jpeg',
    cleanBase64String: true,
  });

  const manifestoPathname = new URL(projectExportUrl).pathname;
  const manifestoFilename = manifestoPathname.substring(1); // Remove leading slash to get filename

  const responseInternalAnnuncio = await createOrUpdateInternalAnnuncioFunebre({
    visibile: annuncioVisible,
    comune: {
      nome: comune.text,
      codice: comune.value,
    },
    mail_famiglia,
    sms_famiglia,
    fotoUrl,
    fotoFilename,
    manifestoUrl: projectExportUrl,
    manifestoFilename,
  });

  if (!responseInternalAnnuncio || !responseInternalAnnuncio.objectId) {
    showLoaderAf("Errore durante la creazione dell'annuncio");
    onErrorShowMessage(false, {
      icon: 'error',
      title: 'Errore',
      text: "Non è stato possibile creare l'annuncio funebre",
      confirmButtonColor: '#278e8e',
    });
    return;
  }

  const data = {
    codice_impresa: user.org_pointer.objectId,
    codice_annuncio: responseInternalAnnuncio.objectId,
    tipo: mapGiottoProjectEventToAFType(templatesCategory.name.toLowerCase()),
    servizioId: servizio.objectId,
    nome: servizio.nome,
    cognome: servizio.cognome,
    data_morte: servizio.data_morte.substr(0, 10),
    comune: comune.value,
    visibile: annuncioVisible,
    manifesto: {
      url: projectExportUrl,
    },
    foto: {
      url: fotoUrl || foto,
    },
    paese: 'N/D',
    mail_famiglia,
    sms_famiglia,
    nascondi_cordogli: false,
    defunto: servizio,
  };

  // Only add eta if both birth and death dates are available
  if (servizio.data_nascita && servizio.data_morte) {
    data.eta = calculateAge(servizio.data_nascita, servizio.data_morte);
  }

  let roomReservations;
  try {
    roomReservations = await fetchRoomReservationsByFuneralService(
      servizio.objectId
    );
  } catch (err) {
    console.error(err);
    onErrorShowMessage();
    return;
  }

  for (const roomReservation of roomReservations) {
    if (!data.stanze) {
      data.stanze = [];
    }
    data.stanze.push({
      id: roomReservation.room_pointer.objectId,
      nome_stanza: roomReservation.room_pointer.name,
      dal: roomReservation.from,
      al: roomReservation.to,
    });
  }

  if (chiesa && chiesa.nome) {
    data.nome_chiesa = chiesa.nome;
  }
  if (chiesa && chiesa.indirizzo) {
    data.indirizzo_chiesa = chiesa.indirizzo;
  }
  if (chiesa && chiesa.citta) {
    data.citta_chiesa = chiesa.citta;
  }

  if (servizio.cimitero) {
    data.nome_cimitero = servizio.cimitero;
  }

  if (servizio.data_funerale) {
    data.data_funerale = servizio.data_funerale.substr(0, 10);
  }

  let endpoint;

  if (
    window.editorConfig.annunciFunebri?.link_annuncifunebri ||
    window.editorConfig.annunciFunebri?.link_cliente ||
    (window.editorConfig.annunciFunebri?.visibile === false &&
      window.editorConfig.annunciFunebri?.updatedAt)
  ) {
    endpoint = 'update';
  } else {
    endpoint = 'create';
  }

  let response;

  try {
    response = await axios.post(
      `${process.env.ANNUNCI_FUNEBRI_API_URL}/${endpoint}`,
      { data }
    );
    if (response.data.code > 300) {
      throw response.data;
    }
  } catch (err) {
    console.error(err);
    onErrorShowMessage(false, {
      icon: 'error',
      title: 'Errore',
      text: "Non è stato possibile pubblicare l'annuncio su AnnunciFunebri.it",
      confirmButtonColor: '#278e8e',
    });
    return;
  }

  await createOrUpdateInternalAnnuncioFunebre({
    ...response.data,
    manifestoUrl: projectExportUrl,
    manifestoFilename,
  });

  showSuccessAf("L'annuncio &egrave; stato pubblicato con successo.");
  await checkAndEnableAfButton();
};

export const handleAfPhotoSelection = (url) => {
  modifyState('afSelectPhotoActive', false);
  modifyState('afSelectPhotoUrl', url);
  hideSidebarTab('allegati');
  $('#editor-sidebar-af-select-photo-description').hide();
  $('#editor-sidebar-af-photo').attr('src', url).show();
  showSidebarTab('annuncio-funebre');
  $('#editor-sidebar-af-select-photo').removeClass('ofc-has-error');
};

const handleAfSelectPhoto = () => {
  modifyState('afSelectPhotoActive', true);
  hideSidebarTab('annuncio-funebre');
  handleTabAttachments();
  showSidebarTab('allegati');
};

const initAnnunciFunebri = () => {
  initSelect2Comuni();
  $('body').on(
    'click',
    '#editor-sidebar-af-publish-annuncio',
    publishExternalAnnuncioFunebre
  );
  $('body').on(
    'click',
    '#editor-sidebar-af-delete-annuncio',
    deleteExternalAnnuncioFunebre
  );
  // Remove the change handler as it's not needed - the checkbox state is just for UI
  // The actual value is sent when publishing
  $('body').on('click', '#editor-sidebar-af-select-photo', handleAfSelectPhoto);
  $('body').on('click', '#editor-sidebar-af-open-chat', requestNewInfoAf);

  isInitAnnunciFunebri = true;
};

export const handleTabAnnunciFunebri = async () => {
  if (!isInitAnnunciFunebri) {
    initAnnunciFunebri();
  }

  // Show loading spinner initially
  $('#editor-sidebar-af-loading').removeClass('d-none');
  $('#editor-sidebar-af-disable').addClass('d-none');
  $('#editor-sidebar-af-enable').addClass('d-none');

  const { user } = await getUser();
  if (!user.org_pointer.integrazione_annunci_funebri) {
    // Hide loading and show disable message
    $('#editor-sidebar-af-loading').addClass('d-none');
    $('#editor-sidebar-af-disable').removeClass('d-none');
    $('#editor-sidebar-af-youtube-iframe').attr(
      'src',
      'https://www.youtube.com/embed/9juQSK206Xg?rel=0'
    );
    trackEvent('Upselling', {
      type: 'click',
      source: 'sidebar',
      success: true,
      offer: 'annunci funebri',
      purpose: 'see obituaries',
      intent: 'obituaries',
    });
    return;
  }

  // Always fetch fresh data when opening the sidebar
  fetchAnnuncioFunebre()
    .then((response) => {
      console.log('Fetched annuncio funebre:', response);
      window.editorConfig.annunciFunebri = response;
      // Hide loading and show enable section
      $('#editor-sidebar-af-loading').addClass('d-none');
      $('#editor-sidebar-af-enable').removeClass('d-none');
      checkAndEnableAfButton();
    })
    .catch((error) => {
      console.error('Error fetching annuncio funebre:', error);
      // Hide loading and show enable section even on error
      $('#editor-sidebar-af-loading').addClass('d-none');
      $('#editor-sidebar-af-enable').removeClass('d-none');
      // Clear any stale data
      window.editorConfig.annunciFunebri = null;
      checkAndEnableAfButton();
    });
};
